/*
 * Moves the Glopal country selector (#wi-country-selector-button), which Glopal's
 * script appends to <body>, into the header slot rendered by
 * sections/limely-header.liquid. assets/limely-header.css positions the slot.
 */
(function () {
  const BUTTON_ID = 'wi-country-selector-button';

  function place() {
    const button = document.getElementById(BUTTON_ID);
    const slot = document.querySelector('.limely-glopal-slot');
    if (button && slot && button.parentElement !== slot) slot.appendChild(button);
  }

  // Glopal injects the button some time after load, so watch <body> for it
  new MutationObserver(place).observe(document.body, { childList: true });
  place();
})();
